module.exports = __webpack_public_path__ + "img/user-placeholder.998d622.png";